import { ConfigProvider } from "antd";
import { Toaster } from "react-hot-toast";
import { Navigate, Route, Routes } from "react-router-dom";
import Activities from "./pages/Activity";
import Clients from "./pages/Clients";
import Dashboard from "./pages/Dashboard";
import AppLayout from "./pages/layout";
import Orders from "./pages/Orders";
import Services from "./pages/Services";
import Staffs from "./pages/Staffs";
import Stores from "./pages/Stores";
import Users from "./pages/Users";
import { StoreProvider } from "./context/StoreContext";
import CreateService from "./pages/CreateService";
import CreateOrderV2 from "./pages/CreateOrderV2";
import OrderDetails from "./pages/OrderDetails";
import Reports from "./pages/Reports";
import ComprehensiveReportPage from "./pages/ComprehensiveReport";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          // ✅ Global primary color
          colorPrimary: "#FF5722", // Example: deep orange
        },
        components: {
          Layout: {
            colorBgBase: "#252525",
            siderBg: "#252525",
          },
          Menu: {
            darkItemBg: "#252525",
            darkSubMenuItemBg: "#252525",
          },
          InputNumber: {
            handleVisible: true,
          },
        },
      }}
    >
      <div>
        <Toaster position="top-right" reverseOrder={false} />
        <StoreProvider>
          <Routes>
            <Route path="/*" element={<AppLayout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="users" element={<Users />} />
              <Route path="staffs" element={<Staffs />} />
              <Route path="stores" element={<Stores />} />
              <Route path="clients" element={<Clients />} />
              <Route path="services" element={<Services />} />
              <Route path="services/:id" element={<CreateService />} />
              <Route path="services/create" element={<CreateService />} />
              <Route path="orders" element={<Orders />} />
              <Route path="activity" element={<Activities />} />
              <Route path="orders/create" element={<CreateOrderV2 />} />
              <Route path="orders/:id" element={<OrderDetails />} />
              <Route path="reports/eod" element={<Reports />} />
              <Route
                path="reports/comprehensive"
                element={<ComprehensiveReportPage />}
              />
              <Route path="*" element={<Navigate to="/dashboard" />} />
            </Route>
          </Routes>
        </StoreProvider>
      </div>
    </ConfigProvider>
  );
}

export default App;
